/**
 *  Property of OSF GLOBAL SERVICES INC. , an OSF Digital company. OSF remains the sole owner of all right, title and interest in the software. Do not copy, sell, reverse engineer or otherwise attempt to derive or obtain information about the functioning, manufacture or operation therein.
 */

module.exports = {
  sorCartPageLogin: require('./sorCartPageLogin'),
  sorAddressForm: require('./sorAddressForm'),
  sorManageRefillOptions: require('./sorManageRefillOptions'),
  sorLinkModal: require('./sorLinkModal'),
  sorResubscribe: require('./sorResubscribe'),
  sorReactivateSubscription: require('./sorReactivateSubscription'),
  sorCreditCard: require('./sorCreditCard'),
  sorOrderView: require('./sorOrderView'),
  sorSubscriptionView: require('./sorSubscriptionView'),
  sorAddProductForm: require('./sorAddProductForm'),
  sorProduct: require('./sorProduct'),
  sorAccountView: require('./sorAccountView'),
  sorSGCheckout: require('./sorSGCheckout'),
  sorToastMessageShow: require('./sorToastMessageShow')
};
